<template>
  <div class="w-full h-full">
    <el-tree
      ref="cockpitTreeRef"
      v-if="!treeLoading"
      @node-click="nodeClick"
      class="w-full h-full bg-transparent text-hex-$cockpitTreeTextColor"
      :filter-node-method="customFilter"
      :class="[organizationUnitId ? 'tree__organizaiton' : '']"
      :data="treeData"
      :node-key="treeOptions.nodeKey"
      :highlight-current="treeOptions.highlightCurrent"
      :expand-on-click-node="treeOptions.expandOnClickNode"
      :accordion="treeOptions.accordion"
      :props="treeOptions.props"
      :default-expanded-keys="defaultExpandedIds"
      :default-expand-all="isExpandAll"
    >
      <div
        slot-scope="{ node }"
        class="flex flex-1 h-28px items-center justify-between overflow-hidden"
        :class="[
          `node__level${node.level}`,
          organizationUnitId && _.eq(node.data.organizationUnitId, node.data.keyId)
            ? 'node__organizaiton'
            : '',
        ]"
      >
        <div
          class="flex items-center pr-20px"
          :class="organizationUnitId ? 'max-w-1/2 min-w-1/4' : 'w-full'"
        >
          <div
            class="text-hex-$cockpitTreeTextColor w-full truncate cockpit-node__label"
            :title="node.label"
          >
            {{ node.label }}
          </div>
        </div>
        <div
          v-if="organizationUnitId && !_.eq(node.data.organizationUnitId, node.data.keyId)"
          class="flex-1 flex"
        >
          <div class="w-full flex justify-end">
            <slot class="" name="btns" :node="node"></slot>
          </div>
        </div>
        <div
          class="hidden absolute hidden true-node__item--highlight"
          :class="
            organizationUnitId && !_.eq(node.data.organizationUnitId, node.data.keyId)
              ? 'h-[calc(100%-4px)] top-2px w-94/100 left-3/100 rounded-4px'
              : 'h-full top-0 w-full left-0 rounded-0'
          "
        ></div>
      </div>
    </el-tree>
  </div>
</template>

<script>
import { isEmpty, eq, get, includes, forEach } from 'lodash'

export default {
  name: 'cockpitTree',
  props: {
    // 树加载状态
    treeLoading: {
      type: Boolean,
      default: true,
    },
    // 树数据
    treeData: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 树数据
    customFilter: {
      type: Function,
      default: () => {
        return (value, data) => {
          return includes(data.name, value)
        }
      },
    },
    // 树配置
    treeOptions: {
      type: Object,
      default: () => {
        // 部门和人员同级默认配置
        return {
          props: { children: 'childen', label: 'name', isLeaf: 'leaf' },
          organizationProps: {
            organizationUnitName: 'organizationUnitName',
            organizationUnitId: 'organizationUnitId',
          },
          nodeKey: 'keyId', // 部门和人员联合key
          highlightCurrent: true,
          expandOnClickNode: false,
          accordion: false,
        }
        // 同级下只存在部门使用该配置
        //   treeOptions: {
        //   props: {
        //     children: 'childen',
        //     label: 'name',
        //   },
        //   organizationProps: {},
        //   nodeKey: 'id',
        //   highlightCurrent: true,
        //   expandOnClickNode: false,
        //   accordion: false,
        // },
      },
    },
    // 默认展开节点
    defaultExpandKeys: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 是否默认展开所有节点
    isExpandAll: {
      type: Boolean,
      defalut: false
    }
  },
  data() {
    return {
      defaultExpandedIds: [],
      treeRefFilter: null, // el-tree过滤方法
    }
  },
  mounted() {
    // 初始化树过滤方法
    this.initCockpitTreeFilter()
  },
  computed: {
    // 自定义部门名称
    organizationUnitName() {
      return get(this, 'treeOptions.organizationProps.organizationUnitName')
    },
    // 自定义部门id 只在同级下存在部门和人员时使用
    organizationUnitId() {
      return get(this, 'treeOptions.organizationProps.organizationUnitId')
    },
  },
  methods: {
    // 初始化树过滤方法
    initCockpitTreeFilter() {
      this.$nextTick(() => {
        const filter = this.$refs.cockpitTreeRef?.filter
        this.treeRefFilter = filter || null
      })
    },
    // 树点击事件
    nodeClick(...args) {
      this.$emit('nodeClick', ...args)
    },
    // 同级下存在部门和人员时使用 lazy模式 用下拉箭头区分为部门或者人员
    loadNode(node, resolve) {
      if (eq(node.level, 0)) {
        return resolve(node.data)
      }
      if (isEmpty(node.data[get(this, 'treeOptions.props.children')])) {
        return resolve([])
      }
      const res = node.data[get(this, 'treeOptions.props.children')]
      forEach(res, (item) => {
        item.leaf = !eq(item.keyId, item.organizationUnitId)
      })
      return resolve(res)
    },
  },
  watch: {
    // 初始化树方法
    treeLoading() {
      this.initCockpitTreeFilter()
    },
    treeData: {
      immediate: true,
      handler(value) {
        if (value.length) {
          this.defaultExpandedIds = [...this.defaultExpandKeys, this.treeData[0].keyId]
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 8px;
  background-color: var(--cockpitScrollbar);
}
::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background-color: var(--cockpitScrollbarThumbBg);
}

::v-deep {
  div.el-loading-mask {
    background-color: transparent !important;
  }
  .el-tree-node__content {
    position: relative;
    height: 32px;
    color: var(--cockpitTreeTextColor);
    & > .el-tree-node__expand-icon {
      padding: 6px 2px;
    }
  }
  // 下拉后文字颜色
  .is-expanded > div:first-of-type > div[class*='node__level'] .cockpit-node__label {
    color: var(--cockpitExpandTextColor) !important;
    transition: all 0.4s;
  }
  // 树一级样式
  .el-tree > .el-tree-node {
    .node__level1 {
      font-size: 16px;
      padding: 0 30px 0 20px;
      height: 36px;
      box-sizing: border-box;
      border-radius: 2px;
      border: 1px solid var(--cockpitFirstBorderColor);
      box-shadow: 0px 6px 4px 0px var(--cockpitShadowColor);
    }
    & > .el-tree-node__content {
      position: relative;
      height: fit-content;
      margin-bottom: 10px;
    }
    & > .el-icon-caret-right:before {
      font-size: 16px;
    }
    & > .el-tree-node__content > .el-tree-node__expand-icon.el-icon-caret-right,
    & > .el-tree-node__content > .expanded.el-tree-node__expand-icon.el-icon-caret-right {
      position: absolute;
      right: 4px;
      &::before {
        content: '\e6df';
        background: none;
        transition: all 0.4s;
      }
    }
    & > .el-tree-node__content > .el-tree-node__expand-icon.el-icon-caret-right {
      &::before {
      }
    }
    & > .el-tree-node__content > .expanded.el-tree-node__expand-icon.el-icon-caret-right {
      &::before {
        color: var(--cockpitExpandTextColor);
      }
    }
    & > .el-tree-node__children[role='group'] {
      border: 1px solid transparent;
    }
    &.is-expanded > .el-tree-node__children[role='group'] {
      border: 1px solid var(--cockpitSecondBorderColor);
      margin-bottom: 10px;
    }
  }
  // 树非一级样式
  .el-tree {
    .el-tree-node__expand-icon,
    .el-tree-node__label {
      color: var(--cockpitTreeTextColor);
    }
    .el-tree-node__expand-icon.is-leaf {
      color: transparent;
    }
    &.el-tree--highlight-current .el-tree-node.is-current {
      & > div.el-tree-node__content {
        position: relative;
        background-color: transparent;
        .true-node__item--highlight {
          z-index: -1;
          background: var(--cockpitCurrentBg);
          display: block;
        }
      }
    }
    .el-tree-node:focus > .el-tree-node__content,
    .el-tree-node:focus,
    .el-tree-node__content:hover,
    .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
      background-color: transparent;
    }
    .el-tree-node__expand-icon.expanded {
    }
    //有子节点 且未展开
    .el-icon-caret-right:before,
    .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
      transition: all 0.4s;
      font-size: 18px;
    }
    //有子节点 且已展开
    .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
      color: var(--cockpitExpandTextColor);
    }
    .el-tree-node:focus > .el-tree-node__content,
    .el-tree-node:focus,
    .el-tree-node__content:hover,
    .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
      background-color: transparent;
    }
    .el-tree-node__expand-icon.expanded {
    }
    //有子节点 且未展开
    .el-icon-caret-right:before,
    .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
      transition: all 0.4s;
      font-size: 18px;
      display: block;
      font-size: 16px;
    }
    //有子节点 且已展开
    .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
    }
  }
}
</style>
